module.exports = __webpack_public_path__ + "8663921dd3a47f8cb5858c6808c1fec7.png";